const CONTENT_EDITABLE = '[contenteditable]:not([contenteditable="false"])';

const EDITABLE_SELECTOR = `input, textarea, select, ${CONTENT_EDITABLE}`;

/**
 * Fields that take typed text and own the system text menu. Keep identical to
 * the selector in `native_context_menu_guard_script` (src-tauri/src/lib.rs).
 */
const TEXT_ENTRY_SELECTOR = `textarea, input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]):not([type=color]):not([type=button]):not([type=submit]):not([type=reset]):not([type=image]), ${CONTENT_EDITABLE}`;

function isInside(target: EventTarget | null, selector: string): boolean {
  return target instanceof Element && target.closest(selector) !== null;
}

/** True when the event target is, or sits inside, a form control that takes keys. */
export function isEditableTarget(target: EventTarget | null): boolean {
  return isInside(target, EDITABLE_SELECTOR);
}

/** True when the event target is, or sits inside, a field the user types text into. */
export function isTextEntryTarget(target: EventTarget | null): boolean {
  return isInside(target, TEXT_ENTRY_SELECTOR);
}
